// src/components/shared/Can.js
import React from 'react'
import { useSelector } from 'react-redux'
import { selectHasFeature, selectFeaturesLoaded } from 'store/auth/featureSlice'

/**
 * Use one of:
 *  - feature="X"                (single)
 *  - anyOf={['A','B']}          (OR)
 *  - allOf={['A','B']}          (AND)
 * Optionally invert with `not`, show `fallback` if blocked,
 * and render a `loadingFallback` while features are loading.
 */
export default function Can({
  feature,
  anyOf,
  allOf,
  not = false,
  fallback = null,
  loadingFallback = null,
  children,
}) {
  const loaded = useSelector(selectFeaturesLoaded)
  const featureMap = useSelector(s => s.auth.feature.map)

  if (!loaded) return loadingFallback

  let allowed = true
  if (feature) allowed = !!featureMap[feature]
  if (anyOf)   allowed = anyOf.some(f => !!featureMap[f])
  if (allOf)   allowed = allOf.every(f => !!featureMap[f])
  if (not)     allowed = !allowed

  return allowed ? <>{children}</> : <>{fallback}</>
}
